import { render, staticRenderFns } from "./BaseDialogButton.vue?vue&type=template&id=59174382&scoped=true"
import script from "./BaseDialogButton.vue?vue&type=script&lang=js"
export * from "./BaseDialogButton.vue?vue&type=script&lang=js"
import style0 from "./BaseDialogButton.vue?vue&type=style&index=0&id=59174382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59174382",
  null
  
)

export default component.exports